import { dispatcher } from '../redux/redux';

export default function handlerPopup({ name, ...props }) {
    dispatcher({ type: name, data: { ...props } });
}
